
export default function Spinner({ size = 24 }: { size?: number }) {
  const style: React.CSSProperties = {
    display: 'inline-block',
    width: size,
    height: size,
    borderRadius: '50%',
    border: '2px solid currentColor',
    borderTopColor: 'transparent',
    animation: 'spin 0.7s linear infinite',
  };
  return (
    <>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div role="status" aria-label="loading" style={style} />
    </>
  );
}
